export default {
  ExpenseInvest: 1, // chi đầu tư
  ExpenseRegular: 2, // chi thường xuyên
  ExpenseProgram: 3, // chi CTMT
  CalculationBasis: 4, // Cơ sở tính
  ExpenseOther: 5, // chi khác
};